<template>
  <div class="row">
    <div
      class="col-xl-6 col-lg-4 col-xxxl-4 col-sm-6"
      v-for="stat in elements"
      :key="stat.id"
    >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              :class="['icon position-relative rounded-circle text-center',
                stat.color ]"
            >
              <i :class="stat?.icone"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ stat.libelle }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ stat.sign }}{{ stat.totalDay }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                {{ stat.sign }}{{ stat.totalDayBefore }}
              </span>
              <span :class="['fw-bold text-success ms-11', stat.color]">
                {{ stat.pourcentage }}%
                <i
                  :class="[
                    stat.iconUpDown,
                    'fs-12 lh-1 position-relative top-1',
                  ]"
                >
                </i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

import statsBoxes from "./statsBoxes.json";
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";

export default defineComponent({
  name: "StatsBoxes",
  setup() { 

    const elements = ref<Array<any>>([])
      
    function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/ventes-stats?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          elements.value = data.data;
          console.log('elements', elements.value);
        })
        .catch(({ response }) => {
          error(response.data);
          console.log('errrrrr', response.data);
          // isLoading.value = false;
        });
    }
  
    onMounted(async () => {
      await getAll();
      console.log("maman line");
    });

    const data = [
      {
          "id": 1,
          "class": "text-primary",
          "icon": "flaticon-sterile-box",
          "title": "VV",
          "sign": "",
          "currentValue": "15,209",
          "previousValue": "13,456",
          "classTwo": "text-success",
          "percent": "5.5",
          "iconUpDown": "flaticon-up-arrow"
      },
    ];

    return {
      elements,
    };
  },
});
</script>